import React, { useCallback, useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import calender from "../../assets/blueCalendar.svg";
import LoaderComponent from "../../ReusableComponents/LoaderComponent";
import TableViewPagination from "../../ReusableComponents/TableView/TableViewPagination";
import _debounce from "lodash/debounce";
import dateFormat from "dateformat";
import Popup from "../../ReusableFunctions/Popup";
import { useNavigate } from "react-router";
import { ROUTES } from "../../routes";
import Loading from "../../ReusableFunctions/Loader";
import {
  getDspLeadInvoices,
  getDspSubsubscriptionInvoices,
  // getSettlementInvoices,
  getCustomerInvoices,
} from "../../apis/settlements";
import NotFounds from "../../ReusableComponents/NotFounds";
import noRequest from "../../assets/no-request.svg";
import ClearFilterButton from "../../ReusableComponents/TableView/ClearFilterButton";
import TabComponent from "./TabComponent";
import { formatAmountWithSymbol } from "../../ReusableFunctions/reusableFunctions";
import { useSelector } from "react-redux";

const defaultTabs = [
  {
    id: "Service",
    label: "Service",
  },
  {
    id: "Leads",
    label: "Leads",
  },
  {
    id: "Subscription",
    label: "Subscription",
  },
];

const DspInvoices = ({ dsp, user }) => {
  const navigate = useNavigate();
  const isFirstRender = useRef(true);
   const reduxUser = useSelector((state) => state.user?.user);
  
  const [openDatePicker, setOpenDatePicker] = useState({
    fromDate: false,
    toDate: false,
  });
  const [filters, setFilters] = useState(() => {
    const savedFilters = localStorage.getItem("dspInvoicesFilters");
    return savedFilters
      ? JSON.parse(savedFilters)
      : {
          fromDate: undefined,
          toDate: undefined,
          pageNumber: 1,
          pageSize: 10,
          selectedTab: "Service",
        };
  });
  const [tableLoading, setTableLoading] = useState(false);
  const [settlementInvoices, setSettlementInvoices] = useState([]);

  const getDspSettlementInvoicesFunc = async () => {
    try {
      setTableLoading(true);
      const fromDate = filters.fromDate
        ? new Date(filters.fromDate).toISOString()
        : undefined;
      const toDate = filters.toDate
        ? new Date(filters.toDate).toISOString()
        : undefined;

      let invoices = [];
      // if (filters.selectedTab === "Service") {
      //   invoices = await getSettlementInvoices(
      //     dsp?.id,
      //     fromDate,
      //     toDate,
      //     filters.pageSize,
      //     filters.pageNumber,
      //   );
      if (filters.selectedTab === "Service") {
        invoices = await getCustomerInvoices(
          dsp?.id,
          fromDate,
          toDate,
          filters.pageSize,
          filters.pageNumber,
        );
        if (invoices?.length > 0) {
          invoices = invoices.map((inv) => ({
            ...inv,
            total_dsp_amount_to_be_paid: Number(inv.total_amount),
            generated_time: inv.service_time,
            settlement_invoices_count: inv.total_count,
            status: "settled",
          }));
        }
      } else if (filters.selectedTab === "Leads") {
        invoices = await getDspLeadInvoices(
          fromDate,
          toDate,
          filters.pageSize,
          filters.pageNumber,
        );
        if (invoices.length > 0) {
          invoices = invoices.map((inv) => {
            return {
              ...inv,
              total_dsp_amount_to_be_paid: Number(inv.total_amount_with_gst),
            };
          });
        }
      } else if (filters.selectedTab === "Subscription") {
        invoices = await getDspSubsubscriptionInvoices(
          fromDate,
          toDate,
          filters.pageSize,
          filters.pageNumber,
        );
        if (invoices.length > 0) {
          invoices = invoices.map((inv) => {
            let gst_amount = Number(inv.total_amount) * Number(0.18);
            return {
              ...inv,
              total_dsp_amount_to_be_paid:
                Number(inv.total_amount) + gst_amount,
            };
          });
        }
      }

      setSettlementInvoices(invoices);
    } catch (error) {
      Popup.alert("Error", error, "ERROR");
    } finally {
      setTableLoading(false);
      Loading.set(false);
    }
  };
  useEffect(() => {
    localStorage.setItem("dspInvoicesFilters", JSON.stringify(filters));
  }, [filters]);

  const updateFilters = useCallback((newFilters) => {
    setFilters((prev) => {
      const updated = { ...prev, ...newFilters };
      localStorage.setItem("dspInvoicesFilters", JSON.stringify(updated));
      return updated;
    });
  }, []);

  const clearFilters = () => {
    setFilters((prevFilter) => ({
      ...prevFilter,
      fromDate: undefined,
      toDate: undefined,
    }));
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setOpenDatePicker((prev) => ({ ...prev, fromDate: false, toDate: false }));
    const debouncedGetSettelmentInvoicesDSPs = _debounce(() => {
      getDspSettlementInvoicesFunc();
    }, 300);

    debouncedGetSettelmentInvoicesDSPs();

    return () => {
      debouncedGetSettelmentInvoicesDSPs.cancel();
    };
  }, [filters.pageNumber, filters.fromDate, filters.toDate]);

  useEffect(() => {
    getDspSettlementInvoicesFunc();
  }, [filters.selectedTab]);


  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "15px 40px",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div className="flex justify-between w-[50%] items-center ">
          <div style={{ width: "30%" }}>
            <h4>Invoices History</h4>
          </div>
          <div className="w-[70%] h-fit ml-[5px] ">
            <TabComponent
              tabData={defaultTabs}
              activeTab={filters.selectedTab}
              onTabChange={(selectedTab) => {
                setFilters((prevFilters) => {
                  return {
                    ...prevFilters,
                    selectedTab,
                  };
                });
              }}
            />
          </div>
        </div>
        <div className="filters_section_wrapper">
          <div>
            <ClearFilterButton
              isVisible={filters.fromDate || filters.toDate}
              onClick={clearFilters}
            />
          </div>
          <div className="date_Filters">
            <div
              className="input-date "
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                height: "34px",
                width: "150px",
                position: "relative",
                background: "transparent",
              }}
              onClick={() =>
                setOpenDatePicker((prev) => ({ ...prev, fromDate: true }))
              }
            >
              <DatePicker
                dateFormat="dd/MM/yyyy"
                onClickOutside={() =>
                  setOpenDatePicker((prev) => ({ ...prev, fromDate: false }))
                }
                open={openDatePicker.fromDate}
                placeholderText="From Date"
                maxDate={filters?.toDate && new Date(filters?.toDate)}
                readOnly
                className="input-date-hidden"
                selected={filters.fromDate ? new Date(filters.fromDate) : null}
                onChange={(date) => {
                  if (date) {
                    let fromDate = new Date(date).setHours(0, 0, 0, 0);
                    fromDate = new Date(fromDate).toISOString();
                    updateFilters({ fromDate });
                  }
                }}
              />
              <img
                src={calender}
                style={{ width: "18px", position: "absolute", right: "15px" }}
              />
            </div>
            <div className="text-xl">-</div>
            <div
              className="input-date  "
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                height: "34px",
                width: "150px",
                position: "relative",
                background: "transparent",
              }}
              onClick={() => {
                if (filters?.fromDate) {
                  setOpenDatePicker((prev) => ({ ...prev, toDate: true }));
                }
              }}
            >
              <DatePicker
                placeholderText="To Date"
                dateFormat="dd/MM/yyyy"
                onClickOutside={() =>
                  setOpenDatePicker((prev) => ({ ...prev, toDate: false }))
                }
                open={openDatePicker.toDate}
                disabled={!filters.fromDate}
                minDate={filters?.fromDate && new Date(filters?.fromDate)}
                maxDate={new Date()}
                readOnly
                className="input-date-hidden "
                selected={filters.toDate ? new Date(filters.toDate) : null}
                onChange={(date) => {
                  if (date) {
                    let todate = new Date(date).setHours(23, 59, 59, 999);
                    todate = new Date(todate).toISOString();
                    updateFilters({ toDate: todate });
                  }
                }}
              />
              <img
                src={calender}
                style={{ width: "18px", position: "absolute", right: "15px" }}
              />
            </div>
          </div>
        </div>
      </div>
      {!tableLoading ? (
        <div style={{ width: "100%", padding: "0px 30px 30px" }}>
          <table className="transactionTable">
            <thead className="w-full">
              <tr className="text-[#3B3B3B] text-[14px]">
                <th style={{ paddingLeft: "20px" }}>Invoice No.</th>
                <th style={{ paddingLeft: "20px" }}>Amount</th>
                <th style={{ paddingLeft: "20px" }}>Date</th>
                <th style={{ paddingLeft: "20px" }}>Status</th>
              </tr>
            </thead>
            <div className="invoice_transaction_table_body">
              <tbody>
                {settlementInvoices?.length === 0 ? (
                  <tr align="center">
                    <td colSpan={6} style={{ height: "228px" }}>
                      <NotFounds
                        imgUrl={noRequest}
                        msg={"No data available!"}
                        hideBtn
                        imgStyle={{ width: "100px" }}
                      />
                    </td>
                  </tr>
                ) : (
                  settlementInvoices &&
                  settlementInvoices?.map((invoice, index) => (
                    <tr
                      className="row-hover"
                      style={{ cursor: "pointer" }}
                      key={index}
                      onClick={() => {
                        switch (filters.selectedTab) {
                          case "Service":
                            console.log("invoice data:", invoice);
                            navigate(`${ROUTES.PAYMENTINVOICE}`, {
                              state: {
                                dsp,
                                invoice,
                              },
                            });
                            break;
                          case "Leads":
                            navigate(`${ROUTES.LEADINVOICEDETAILS}`, {
                              state: {
                                dsp,
                                invoice,
                              },
                            });
                            break;

                          case "Subscription":
                            navigate(`${ROUTES.SUBSCRIPTION_INVOICE_DETAILS}`, {
                              state: {
                                dsp,
                                invoice,
                              },
                            });
                            break;
                          default:
                            break;
                        }
                      }}
                    >
                      <td style={{ paddingLeft: "20px" }}>
                        {invoice?.invoice_number}
                      </td>
                      {/* <td style={{ paddingLeft: "20px" }}>{formatAmountWithSymbol(invoice?.total_dsp_amount_to_be_paid, user?.country_code)}</td> */}
                      <td style={{ paddingLeft: "20px" }}>
                        {invoice?.status==="settled"?
                        <td>
                          {formatAmountWithSymbol(
                            invoice?.total_dsp_amount_to_be_paid,
                            user?.country_code,
                            invoice?.invoice_currency,
                            // dsp?.invoice_currency
                          )}
                        </td>
: <td>
                          {formatAmountWithSymbol(
                            invoice?.total_dsp_amount_to_be_paid,
                            user?.country_code,
                            // invoice?.invoice_currency,
                            reduxUser?.dsp?.invoice_currency
                          )}
                        </td>}

                      </td>
                      <td style={{ paddingLeft: "20px" }}>
                        {dateFormat(invoice?.generated_time, "dd mmm yyyy")}
                      </td>
                      <td style={{ paddingLeft: "20px" }}>
                        {invoice?.status == "settled" ? "Paid" : "Unpaid"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </div>
          </table>
        </div>
      ) : (
        <div className="dsp_invoice_loading">
          <LoaderComponent width={"2%"} height={"2%"} />
        </div>
      )}

      {settlementInvoices?.length === 0 ? (
        <></>
      ) : (
        <div className="flex w-full justify-end mt-5">
          <TableViewPagination
            isLoading={false}
            currentPage={filters?.pageNumber || 1}
            totalCount={settlementInvoices[0].settlement_invoices_count}
            pageSize={filters.pageSize}
            padding="10px 5px"
            onPageChange={(page) => {
              updateFilters({ pageNumber: page });
            }}
          />
        </div>
      )}
    </>
  );
};

export default DspInvoices;
